import { Link } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import { SharedButton, SharedCard, SharedProgressBar } from "../../components/shared";
import ClientDocuments from "../../components/documents/ClientDocuments";
import { useAuth } from "../../js/hooks/useAuth";
import { useSellerState, setJourneyMode } from "../../js/state/sellerState";
import { sellerProgress } from "../../js/utils/sellerSteps";
import DeskPlatformBadge from "../../components/desk/DeskPlatformBadge";

export default function SellerHome() {
  const { session, role, isAuthenticated } = useAuth();
  const { seller } = useSellerState();
  const progress = sellerProgress(seller.portfolio);
  const signedIn = isAuthenticated && (role === "seller" || role === "admin");

  return (
    <AppLayout variant="seller" showSellerNav>
      <section className="hero-panel" data-tour="seller-hero">
        <DeskPlatformBadge />
        <h1>{signedIn ? "Seller Dashboard" : "Seller Home"}</h1>
        <p>
          Your listing brief stays on the seller path. Walk the portfolio when you are ready, keep
          notes with your agent, and save a few documents on this device.
        </p>
      </section>

      <div className="row start-actions">
        <SharedButton
          variant="primary"
          to="/seller/welcome"
          onClick={() => setJourneyMode("seller")}
        >
          Continue seller portfolio
        </SharedButton>
        {signedIn ? (
          <>
            <Link to="/client/messages" className="ghost-btn">
              Messages with your agent
            </Link>
            <Link to="/backup" className="ghost-btn">
              Backup &amp; export
            </Link>
            <Link to="/restore" className="ghost-btn">
              Restore points
            </Link>
          </>
        ) : (
          <Link to="/seller/login" className="ghost-btn">
            Seller sign in
          </Link>
        )}
      </div>

      <div data-tour="seller-progress">
        <SharedCard title="Portfolio progress">
          <SharedProgressBar percent={progress.percent} label="Saved portfolio progress" />
          <p className="muted" style={{ marginTop: "0.75rem" }}>
            {progress.done} of {progress.total} sections have notes.
          </p>
        </SharedCard>
      </div>

      <ClientDocuments ownerId={signedIn ? session?.userId : ""} role="seller" />
    </AppLayout>
  );
}
